import {
  from as observableFrom,
  Subject,
  Observable,
  BehaviorSubject,
  throwError,
  ReplaySubject
} from 'rxjs';

import { map, catchError, retry, share, debounceTime } from 'rxjs/operators';
import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { API_SERVER } from '@pcplus/domain-core';
import { LoginInfo } from '../../dto/login-info';
import { KEEP_ALIVE_INTERVAL } from '../../tokens';
import { PubsubService } from '@pcplus/core';

// export class TokenContainer {
//   token: string | null = null;
// }

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
  private _currentUser$: ReplaySubject<string | null>;
  public currentUser$: Observable<string | null>;
  private anyCommunication$ = new Subject<void>();

  constructor(
    private http: HttpClient,
    private pubsub: PubsubService,
    @Inject(API_SERVER) private apiServer: string,
    @Inject(KEEP_ALIVE_INTERVAL) keepAliveInterval: number
  ) {
    this._currentUser$ = new ReplaySubject<string | null>(1);
    this.pubsub
      .subscribe('InterceptingHttpRequest')
      .subscribe(() => this.resetKeepAlive());
    this.currentUser$ = this._currentUser$.asObservable();
    if (keepAliveInterval > 0) {
      this.anyCommunication$
        .pipe(debounceTime(keepAliveInterval * 1000 * 60))
        .subscribe(() =>
          this.http.get(this.apiServer + 'keepAlive').subscribe()
        );
      this.resetKeepAlive();
    }
    const saved = localStorage.getItem('currentUser');
    if (saved) {
      this._currentUser$.next(saved);
    } else {
      this._currentUser$.next(null);
    }
  }

  resetKeepAlive() {
    this.anyCommunication$.next();
  }

  login(username: string, password: string): Observable<boolean> {
    return this.http
      .post(this.apiServer + 'token', new LoginInfo(username, password))
      .pipe(
        map((response) => {
          if (response) {
            localStorage.setItem('currentUser', username);
            this._currentUser$.next(username);
            // return true to indicate successful login
            return true;
          }
          return false;
        }),
        catchError((err) => observableFrom([false]))
      );
  }

  logout(): void {
    const saved = localStorage.getItem('currentUser');
    if (saved) {
      this.http.post<boolean>(`${this.apiServer}logout`, null).subscribe({
        complete: () => {
          // clear token remove user from local storage to log user out
          this._currentUser$.next(null);
          localStorage.removeItem('currentUser');
        }
      });
    } else {
      this._currentUser$.next(null);
    }
  }
}
